export default __webpack_public_path__ + "static/Plots0017-c22be9f52a0db466b8a3e6fc6a7563fa.jpg";